<template>
    <div v-click-outside="hide">
        <div @click="status=true">
            <img width="100px" height="auto" :src="thumbnail" class="img-thumbnail" />
        </div>

        <div v-if="showToolbar">
            <a :href="original" download>
                <i class="fa fa-download"></i> İndir
            </a>
            <a href="#" @click.prevent="rotate">
                <span v-if="isRotating" >
                    <i class="fa fa-spinner"></i> Döndürülüyor
                </span>
                <span  v-else>
                    <i class="fa fa-repeat"></i> Döndür
                </span>


            </a>
        </div>
        <div v-if="status" >
            <transition name="modal">
                <div class="modal-mask centered-modal" >
                    <div class="modal-wrapper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" @click="hide">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Resim</h4>
                                </div>
                                <div class="modal-body">
                                    <v-zoomer>
                                        <img class="img-fluid" :src="original">
                                    </v-zoomer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script type="javascript">

    import ClickOutside from 'vue-click-outside'
    import Vue from 'vue'
    import VueZoomer from 'vue-zoomer'
    import './css/vue-zoomer.css'
    import service from './service'

    Vue.use(VueZoomer)


    export default {
        name: 'ImageModal',
        props: ['original', 'thumbnail', 'token', 'showToolbar'],
        components: { },
        data() {
            return {
                status: false,
                service,
                isRotating: false
            }
        },
        methods: {
            hide(){
                this.status = false
            },
            rotate(){
                const key = this.original.substring(this.original.lastIndexOf('/') + 1)
                this.isRotating = true;
                service
                    .request({
                        url: '/helpers/rotate',
                        type: 'POST',
                        token: this.token,
                        body: {
                            'key': key
                        }
                    })
                    .then(response => {
                        window.location.reload();
                    })
            }
        },
        directives: {
            ClickOutside
        }
    }

</script>

<style>
    .dict-button{
        background-color: #ffffff;
        -moz-border-radius: 28px;
        -webkit-border-radius: 28px;
        border-radius: 28px;
        border: 1px solid #000000;
        display: inline-block;
        cursor: pointer;
        color: #000000;
        font-family: Arial;
        font-size: 15px;
        padding: 0px 24px;
        text-decoration: none;
    }

    #previewContainer {
        border: 1px solid #483f3f73;
        box-shadow: 2px 2px #e2dcdc;
        padding: 10px;
    }

    .centered-modal{
        position: fixed;
        width: 100%;
        height: auto;
        left: 0;
        top: 0;
        z-index: 9999999;
    }

</style>


// WEBPACK FOOTER //
// resources/vue/image-modal.vue